<div class="row">
    @if (showBondData && bond.price > 0) {
        <div class="col-auto">
            <table class="table table-borderless definitions w-100">
                <tbody>
                    <tr>
                        <td>Price:</td>
                        {{ bond.price | currency: 'USD': 'symbol' }}
                        <td>
                            @if (delta == 'increase') {
                                <i-bs [name]="iconNames.CaretUpFill" class="d-inline-block" style="color: #0f0"></i-bs>
                            } @else if (delta == 'decrease') {
                                <i-bs [name]="iconNames.CaretDownFill" class="d-inline-block" style="color: #f00"></i-bs>
                            } @else {
                                <span class="d-inline-block" style="width: 16px"></span>
                            }

                        </td>
                    </tr>
                    @if (bond.couponRate) {
                    <tr>
                        <td>Coupon Rate:</td>
                        <td>{{ bond.couponRate}}%
                        </td>
                    </tr>
                    }
                    @if (bond.maturityDate) {
                    <tr>
                        <td>Maturity Date:</td>
                        <td>{{ bond.maturityDate | date}}
                        </td>
                    </tr>
                    }
                    @if (bond.yield) {
                    <tr>
                        <td>Yield:</td>
                        <td>{{ bond.yield}}%
                        </td>
                    </tr>
                    }
                    @if (bond.weeklyVolume) {
                    <tr>
                        <td>Volume Last Week:</td>
                        <td>{{ bond.weeklyVolume}}
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    }
    @if (chartData.series) {
            <div class="col">
            <div echarts [options]="chartData" style="height: 400px"></div>
        </div>
    }
</div>